<template>
  <div class="search-common-cell">
    <div class="left">
      <span :class="msg.type | getType"></span>
      <p>{{ getTypeTxt(msg.type) }}</p>
    </div>
    <div class="right">
      <h6 v-html="titleTrans(msg.name)" v-if="$store.state.searchWord"></h6>
      <h6 v-else>{{ msg.name }}</h6>
      <p>{{ trainType(msg.trainplan_type) }}：{{ msg.trainplan_name }}</p>
    </div>
    <span class="next-img"></span>
  </div>
</template>

<script>
export default {
  name: "SearchCell",
  data() {
    return {
      type: "paper",
      keyWord: this.$store.state.searchWord,
      title: "",
    };
  },
  props: ["msg"],
  methods: {
    titleTrans(name) {
      let keyword = this.$store.state.searchWord;
      if (keyword != "") {
        // name = name.replace(keyword,'<span>'+keyword+'</span>');
        // 匹配关键字正则
        keyword =
          "(" +
          keyword
            .replace(/([\+\.\*\|\?\-\(\[\^\$])/g, "\\$1")
            .replace(/\s+/g, "|") +
          ")";
        let patt = new RegExp(keyword, "igm");
        // 高亮替换v-html值
        let replaceString = '<span style="color: #f75d5d;">$1</span>';
        // 开始替换
        name = name.replace(patt, replaceString);
      }
      return this.$xss(name);
    },
    getTypeTxt(type) {
      switch (type) {
        case "lesson":
          return this.$t("search.onlineCourse"); // 在线课程
        case "paper":
          return this.$t("search.independentExam"); // 独立考试
        case "face_lesson":
          return this.$t("search.onsiteTraining"); // 面授课程
        case "survey":
          return this.$t("search.queationaire"); // 调查问卷
        case "homework":
          return this.$t("search.assignment"); // 作业
        case "reflection":
          return this.$t("search.reflection"); // 个人反思
        case "case_analysis":
          return this.$t("search.caseAnalysis"); // 案列分析
        case "document":
          return this.$t("search.expandingReading"); // 拓展阅读
        case "html":
          return this.$t("search.articles"); // 文章
        case "pdf":
          return this.$t("search.documents"); // 文档
        case "word":
          return this.$t("search.documents"); // 文档
        case "excel":
          return this.$t("search.documents"); // 文档
        case "ppt":
          return this.$t("search.documents"); // 文档
        case "video":
          return this.$t("search.videos"); // 视频
        case "zip":
          return this.$t("search.package"); // 压缩包
        case "project":
          return this.$t("search.program"); // 学习项目
        case "plan":
          return this.$t("search.trainPlan"); // 培训计划
      }
    },
    trainType(type) {
      type = parseInt(type);
      switch (type) {
        case 1:
          return this.$t("search.categoryPlan"); // 所属计划
        case 2:
          return this.$t("search.categoryProject"); // 所属项目
        default:
          return this.$t("search.category"); // 所属分类
      }
    },
  },
  filters: {
    // 需要定义三个过滤器
    getType(type) {
      switch (type) {
        case "lesson":
          return "online-class";
        case "paper":
          return "paper";
        case "face_lesson":
          return "course";
        case "survey":
          return "questionare";
        case "homework":
          return "homework";
        case "reflection":
          return "self-think";
        case "case_analysis":
          return "case";
        case "document":
          return "read";
        case "html":
          return "txt";
        case "pdf":
          return "doc";
        case "word":
          return "doc";
        case "excel":
          return "doc";
        case "ppt":
          return "doc";
        case "video":
          return "video";
        case "zip":
          return "zip";
        case "project":
          return "project";
        case "plan":
          return "plan";
      }
    },
  },
};
</script>

<style lang="less" scope>
.search-common-cell {
  padding: 0.2rem;
  height: 1.42rem;
  background: #fff;
  display: flex;
  align-items: center;
  margin-top: 0.14rem;
  // box-sizing: content-box;
  .left {
    display: flex;
    flex-direction: column;
    width: 1.08rem;
    padding-right: 0.24rem;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    span {
      display: block;
      width: 0.4rem;
      height: 0.46rem;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center/contain;
      &.project {
        background-image: url("../../assets/img/search/project.png");
      }
      &.plan {
        background-image: url("../../assets/img/search/plan.png");
      }
      &.paper {
        background-image: url("../../assets/img/search/exam2.png");
      }
      &.case {
        background-image: url("../../assets/img/search/case2.png");
      }
      &.homework {
        background-image: url("../../assets/img/search/homework2.png");
      }
      &.online-class {
        background-image: url("../../assets/img/search/online_class2.png");
      }
      &.read {
        background-image: url("../../assets/img/search/reading2.png");
      }
      &.self-think {
        background-image: url("../../assets/img/search/self_think2.png");
      }
      &.questionare {
        background-image: url("../../assets/img/search/questionare2.png");
      }
      &.course {
        background-image: url("../../assets/img/search/xianxia2.png");
      }
      &.video {
        background-image: url("../../assets/img/search/video.png");
      }
      &.doc {
        background-image: url("../../assets/img/search/wendang.png");
      }
      &.txt {
        background-image: url("../../assets/img/search/txt.png");
      }
      &.zip {
        background-image: url("../../assets/img/search/zip.png");
      }
    }
    p {
      font-size: 0.18rem;
      color: #005587;
      text-align: center;
    }
  }
  .right {
    width: 5.8rem;
    padding: 0 0.38rem;
    box-sizing: border-box;
    border-left: 1px solid #e6e6e6;
    h6 {
      line-height: 0.42rem;
      padding-top: 0.1rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #252531;
      font-size: 0.24rem;
      font-weight: bold;
      span {
        color: #f75d5d;
      }
    }
    p {
      line-height: 0.38rem;
      font-size: 0.22rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .next-img {
    display: block;
    height: 100%;
    width: 0.18rem;
    background: url("../../assets/img/search/next.png") no-repeat center/contain;
  }
}
</style>
